import { render, staticRenderFns } from "./PassingThroughBranches.vue?vue&type=template&id=4bb59b68&"
import script from "./PassingThroughBranches.vue?vue&type=script&lang=js&"
export * from "./PassingThroughBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports